import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from "@angular/common";
import { MitterService } from '../../../services/mitter.service';
import {ActivatedRoute, Router, Params } from '@angular/router';
import { connect, createLocalTracks } from 'twilio-video';

@Component({
  selector: 'mitter-video-chat',
  templateUrl: './video-chat.component.html',
  styleUrls: ['./video-chat.component.css']
})
export class VideoChatComponent implements OnInit {
  channelId: string;
  room: any;
  twilioData: object;
  localTracks: any[];

  localTracksAvailable = false;
  remoteTracksAvailable = false;

  constructor(private mitterService: MitterService,
      private location: Location, private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.channelId = params['chatid'];
      this.mitterService.initiateVideoChat(this.channelId)
        .then(data => {
          this.twilioData = data;
          return data;
        })
        .then(twilioData => {
          this.connect(twilioData);
        });
    });
  }

  connect(twilioData) {
    createLocalTracks({
      audio: true,
      video: { width: 600 }
    }).then(localTracks => {
      this.localTracks = localTracks;
      this.localTracksAvailable = true;
      return connect(twilioData.twilioUserAuthorization, {
        name: twilioData.videoRoomId,
        tracks: localTracks
      }).then(room => {
        const component = this;
        this.room = room;
        room.participants.forEach(participant => {
          this.addParticipant(participant, 'mt-video-chat-remote');
        });
        this.addParticipant(room.localParticipant, 'mt-video-chat-self');

        room.on('participantConnected', function(participant) {
        });

        room.on('trackAdded', function(track, participant) {
          component.addParticipant(participant, 'mt-video-chat-remote');
          this.remoteTracksAvailable = true;
        });

        room.on('trackRemoved', function(track, participant) {
          this.remoteTracksAvailable = false;
        });

        room.on('participantDisconnected', function(participant) {
        });

        room.on('disconnected', function() {
        });
      });
    });
  }

  addParticipant(participant, containerName) {
    const container = document.getElementById(containerName);
    if (!container.querySelector('video')) {
      participant.tracks.forEach(function(track) {
        container.appendChild(track.attach());
      });
    }
  }

  goBack() {
    this.localTracks.forEach(track => track.stop());
    this.location.back();
  }

  ngOnDestroy() {
    this.localTracks.forEach(track => track.stop());
    this.room && this.room.disconnect();
  }
}
